import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  showLoading() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("d-none")
    this.overlayTarget.classList.add("d-flex")
  }

  hideLoading() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("d-none")
    this.overlayTarget.classList.remove("d-flex")
  }
}
